<!-- RsaKey下发 -->
<template>
  <a-card :bordered="false">
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="24">
        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :xxl="24">
          <a-form-model-item prop="sysName" label="系统编码(例：kgms)">
            <a-input v-model="form.sysName" placeholder="请填写系统编码" />
          </a-form-model-item>
        </a-col>

        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :xxl="24">
          <a-form-model-item prop="targetIp" label="目标IP(例：127.0.0.1)">
            <a-input v-model="form.targetIp" placeholder="请填写目标IP" />
          </a-form-model-item>
        </a-col>

        <a-col :xs="1" :sm="1">
          <a-button type="primary" icon="check" @click="handleSave" style="margin-bottom: 0">提交</a-button>
        </a-col>
      </a-row>
    </a-form-model>
  </a-card>
</template>
  
  <script>
import { tableMixin } from '@/mixins/tableMixin'
import { getAction } from '@/api/manage'

class formDef {
  sysName = undefined
  targetIp = undefined
  res = undefined
}

export default {
  name: 'RsaKeysManage',
  mixins: [tableMixin],
  data() {
    return {
      // フォーム
      form: new formDef(),
      rules: {
        sysName: [this._r.required],
        targetIp: [this._r.required],
      },
      // 加载中
      loading: false,
      url: {
        save: '/kgms/sys/rsakeys/getRsaPublicKey',
      },
    }
  },
  methods: {
    handleSave() {
      this.$refs.form.validateFieldsAndScroll((ok) => {
        if (ok) {
          if (this.loading) {
            return
          } else {
            this.loading = true
          }

          getAction(this.url.save, this.form)
            .then((res) => {
              if (res.success) {
                this.$message.success(res.message)
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>
<style scoped></style>
